window.customElements.define(
  "ua-breadcrumbs",
  class UABreadcrumbs extends HTMLElement {
    constructor() {
      super();

      this.localStorageKey = "ua-breadcrumbs";

      window.addEventListener("DOMContentLoaded", () => {
        const isProductPage = window.location.href.includes("/products/");

        if (isProductPage) {
          const previousURL = document.referrer;
          if (previousURL && previousURL.includes("/collections/")) {
            this.addCollectionBreadcrumb();
          } else {
            this.removePreviousBreadcrumbs();
          }
        }

        document.querySelectorAll('a[href*="/products/"]').forEach((item) => {
          item.addEventListener("click", (event) => {
            localStorage.removeItem(this.localStorageKey);
          });
        });

        document.querySelectorAll('#product-grid a[href*="/products/"]').forEach((item) => {
          removeEventListener("click", this);
          item.addEventListener("click", (event) => {
            this.saveBreadcrumbs();
          });
        });
      });
    }

    removePreviousBreadcrumbs() {
      localStorage.removeItem(this.localStorageKey);
    }

    saveBreadcrumbs() {
      const currentURL = window.location.href;
      const pageTitle = this.cleanTitle(document.querySelector("h1.collection-hero__title")?.textContent || "");

      if (currentURL.includes("/collections/")) {
        this.removePreviousBreadcrumbs();

        const breadcrumbs = {
          collection: {
            title: pageTitle,
            url: currentURL,
          },
        };

        localStorage.setItem(this.localStorageKey, JSON.stringify(breadcrumbs));
      }
    }

    cleanTitle(title) {
      return title
        .replace(/[\r\n]+/g, "")
        .replace(/^Collection:\s+/i, "")
        .trim()
        .replace(/Collection:\s+/i, "");
    }

    addCollectionBreadcrumb() {
      const previousCollection = localStorage.getItem("ua-breadcrumbs");

      if (previousCollection) {
        const breadcrumbs = JSON.parse(previousCollection);
        const { title, url } = breadcrumbs.collection;
        if (title && url) {
          const ulElement = this.querySelector("ul, ol");

          if (ulElement) {
            const previousURL = document.referrer;

            if (previousURL && previousURL.includes("/products/")) {
              // Don't add the element if the previous URL has 'products' in it
              return;
            }

            const firstLiElement = ulElement.querySelector("li:first-child");
            const liElement = document.createElement("li");
            const aElement = document.createElement("a");

            liElement.classList.add("breadcrumbs__item");

            aElement.href = url;
            aElement.classList.add("breadcrumbs__link");
            aElement.textContent = title;

            if (firstLiElement) {
              ulElement.insertBefore(liElement, firstLiElement.nextSibling);
            } else {
              ulElement.appendChild(liElement);
            }

            liElement.appendChild(aElement);
          }
        }
      }
    }
  }
);
